// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1byfI","content":"styles_content__27M6K"};